import React, { useEffect, useState } from 'react';
import { ArrowLeft, ArrowDown } from 'lucide-react';
import { EventRow } from '../components/EventRow';
import { EventInquiryModal } from '../components/EventInquiryModal';
import { EventSignupModal } from '../components/EventSignupModal';
import { BakeryEvent } from '../types/event';
import { events } from '../data/events';
import { HalloweekCountdown } from '../components/HalloweekCountdown';
import { useCountdown } from '../hooks/useCountdown';
import { HALLOWEEK_LAUNCH_AT as LAUNCH_AT } from '../data/halloweek';
interface EventsProps {
  onBack: () => void;
}
export function Events({
  onBack
}: EventsProps) {
  const [showInquiry, setShowInquiry] = useState(false);
  const [signupEvent, setSignupEvent] = useState<BakeryEvent | null>(null);
  const countdown = useCountdown(LAUNCH_AT);
  // Add ?preview to the URL to see the schedule before launch
  const isPreview = typeof window !== 'undefined' && new URLSearchParams(window.location.search).has('preview');
  const isLaunched = countdown.isDone || isPreview;
  useEffect(() => {
    const previous = document.title;
    const previousBg = document.body.style.backgroundColor;
    document.title = 'Halloweek – Top Notch Bakery';
    document.body.style.backgroundColor = '#0E0C0B';
    return () => {
      document.title = previous;
      document.body.style.backgroundColor = previousBg;
    };
  }, []);
  const today = new Date().toISOString().slice(0, 10);
  const upcoming = events.filter(e => e.date >= today).sort((a, b) => a.date.localeCompare(b.date));
  const scrollToSchedule = () => document.getElementById('schema')?.scrollIntoView({
    behavior: 'smooth'
  });
  return <div className="halloween-theme w-full bg-[#0E0C0B] text-[#F5EDE3]" data-id="element-1360" data-mp="ydktse2evrba">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-8 md:pt-10 pb-20 md:pb-28" data-id="element-1361" data-mp="ybhwd8yxivwj">
        <button onClick={onBack} className="inline-flex items-center gap-2 text-sm font-medium text-[#F5EDE3]/60 hover:text-[#FFB27A] transition-colors" data-id="element-1362" data-mp="am5t0pqa9i25">
          <ArrowLeft className="w-4 h-4" aria-hidden="true" data-id="element-1363" data-mp="vcjeamkb108k" />
          Till startsidan
        </button>

        <header className="mt-10 md:mt-14 mb-10 md:mb-12" data-id="element-1364" data-mp="zd38bh9kznqh">
          <div className="flex flex-wrap items-center justify-between gap-4" data-id="element-1365" data-mp="144uvdhtj3bbv">
            <p className="text-2xl md:text-4xl font-extrabold tracking-tight uppercase" data-id="element-1366" data-mp="194g068vdqdwi">
              Top Notch <span className="text-[#FF7A1A]" data-id="element-1367" data-mp="cegjts8zmb3d">Bakery</span>
            </p>
            <p className="px-4 py-1.5 rounded-full border border-[#F5EDE3]/70 text-sm md:text-base font-medium whitespace-nowrap" data-id="element-1368" data-mp="cg9urjqmvhh6">
              Vecka 44 · 26 okt – 1 nov 2026
            </p>
          </div>

          <div className="mt-2 md:mt-4 flex flex-wrap items-end justify-between gap-6" data-id="element-1369" data-mp="lh7wtwhihex4">
            <h1 className="halloween-display text-[#FF7A1A] text-7xl sm:text-8xl md:text-[9rem] leading-[0.9]" data-id="element-1370" data-mp="qbvepci0fb2q">
              Halloween
            </h1>
            {isLaunched && <button onClick={scrollToSchedule} className="inline-flex items-center gap-2 px-6 py-3.5 rounded-2xl bg-[#FF7A1A] text-[#1A0F08] font-bold hover:bg-[#FF9A4D] transition-colors whitespace-nowrap mb-2" data-id="element-1371" data-mp="21ra9c9mqxquo">
                Boka din plats
                <ArrowDown className="w-4 h-4" aria-hidden="true" data-id="element-1372" data-mp="3cjru62x40ya2" />
              </button>}
          </div>

          <p className="mt-6 max-w-2xl text-[#F5EDE3]/75 text-lg leading-relaxed" data-id="element-1373" data-mp="37k6shkqk2btn">
            En hel vecka av spökligt goda smaker, löpning, mordmysterium och
            disko hos oss på Klostergatan 7 i Växjö.
          </p>
        </header>

        {!isLaunched ? <HalloweekCountdown countdown={countdown} data-id="element-1374" data-mp="2tn9tux473q27" /> : <>
        <section id="schema" aria-labelledby="schedule-heading" className="scroll-mt-16" data-id="element-1375" data-mp="2oo6zq7pr7490">
          <h2 id="schedule-heading" className="sr-only" data-id="element-1376" data-mp="rvn93dawcre6">
            Veckans schema
          </h2>
          {upcoming.length > 0 ? <div className="space-y-3" data-id="element-1377" data-mp="mwk23nbcwb3k">
              {upcoming.map(event => <EventRow key={event.id} event={event} onSignup={setSignupEvent} data-id="element-1378" data-mp="uxrorb8xkdft" />)}
            </div> : <div className="py-16 rounded-2xl bg-[#1C1917] text-center" data-id="element-1379" data-mp="kxr3hjri3n8z">
              <p className="text-2xl font-bold mb-2" data-id="element-1380" data-mp="px3zov49i6o8">
                Inga planerade event just nu
              </p>
              <p className="text-[#F5EDE3]/60" data-id="element-1381" data-mp="c57cn5hgamyp">
                Följ oss på Instagram så missar du inget som är på gång.
              </p>
            </div>}

          <div className="mt-6 rounded-2xl bg-[#FF7A1A] px-6 py-5 md:px-8 md:py-6" data-id="element-1382" data-mp="28b44zrjy0u5">
            <p className="text-xl md:text-2xl font-extrabold text-[#1A0F08]" data-id="element-1383" data-mp="775j1qmef58z">
              Alla aktiviteter behöver förbokas
            </p>
          </div>
        </section>
        </>}

        <section className="mt-16 md:mt-20 grid md:grid-cols-[1fr_auto] gap-6 md:gap-12 items-center border border-[#F5EDE3]/15 rounded-2xl p-8 md:p-10" data-id="element-1384" data-mp="3pf4t3jmmr67c">
          <div data-id="element-1385" data-mp="3aquztudw1e45">
            <h2 className="text-2xl md:text-3xl font-bold mb-2" data-id="element-1386" data-mp="3aqbsf7lv684d">
              Vill du ha ett eget event hos oss?
            </h2>
            <p className="text-[#F5EDE3]/70 leading-relaxed max-w-xl" data-id="element-1387" data-mp="3jqqfocie1xai">
              Vi tar emot privata kurser, provningar och kvällar för företag och
              sällskap. Berätta vad du har i åtanke så återkommer vi.
            </p>
          </div>
          <button onClick={() => setShowInquiry(true)} className="inline-flex justify-center items-center px-7 py-3.5 rounded-full border border-[#F5EDE3]/70 text-sm font-bold hover:bg-[#F5EDE3] hover:text-[#0E0C0B] transition-colors whitespace-nowrap" data-id="element-1388" data-mp="3tnmn0ewjwddh">
            Hör av dig
          </button>
        </section>
      </div>

      {showInquiry && <EventInquiryModal onClose={() => setShowInquiry(false)} data-id="element-1389" data-mp="gb2t5khsukep" />}

      {signupEvent && <EventSignupModal event={signupEvent} onClose={() => setSignupEvent(null)} data-id="element-1390" data-mp="bbzqg6pakq9w" />}
    </div>;
}